// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__7DimR","popupContainer":"Popup_popupContainer__MPvBo","popupContent":"Popup_popupContent__uIwQw","sliderContainer":"Popup_sliderContainer__kDJKd"};